import { render, staticRenderFns } from "./ResultIconAnimation.vue?vue&type=template&id=887e6bb0&scoped=true&"
import script from "./ResultIconAnimation.vue?vue&type=script&lang=js&"
export * from "./ResultIconAnimation.vue?vue&type=script&lang=js&"
import style0 from "./ResultIconAnimation.vue?vue&type=style&index=0&id=887e6bb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887e6bb0",
  null
  
)

export default component.exports